import React, { Component } from 'react';
import { Menu, Icon } from 'antd';
import { RenderMenu } from './renderMenu';
const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

class LeftMenu extends Component {
  render() {
      const {mode,profile,auth} = this.props;
    return (
        <RenderMenu mode={mode} profile={profile} auth={auth}  />
    );
  }
}
export default LeftMenu;